import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MailCheckIcon } from 'lucide-react';
import { AuthLayout } from '../../layouts/AuthLayout';
import { requestPasswordReset } from '../../services/authService';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    if (sending) return;
    setSending(true);
    setError(null);
    try {
      await requestPasswordReset(email);
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Inténtalo de nuevo.');
    } finally {
      setSending(false);
    }
  }
  return <AuthLayout title="Recuperar contraseña" subtitle="Te enviaremos un enlace para crear una contraseña nueva." footer={<Link to="/login" className="font-medium text-primary hover:underline" data-id="element-1398" data-mp="4s47mruevdtx">
          Volver a iniciar sesión
        </Link>} data-id="element-1397" data-mp="2mfoeetayml3v">
      {sent ? <div className="rounded-lg border border-border bg-surface p-6 text-center" data-id="element-1399" data-mp="eiyunyfhehgf">
          <MailCheckIcon className="mx-auto mb-3 h-8 w-8 text-primary" aria-hidden="true" data-id="element-1400" data-mp="9m8d16o13dsw" />
          <p className="text-sm text-foreground" data-id="element-1401" data-mp="3i07a6bmql57z">
            Si existe una cuenta con <strong data-id="element-1402" data-mp="3d25p5l5r2vtv">{email}</strong>, recibirás un correo
            con el enlace de recuperación.
          </p>
        </div> : <form onSubmit={handleSubmit} className="space-y-5" noValidate data-id="element-1403" data-mp="3r2gicuuj8mi7">
          <Input id="email" label="Email" type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} data-id="element-1404" data-mp="3mzk57jnrhiln" />
          {error && <p role="alert" className="text-sm font-medium text-red-600" data-id="element-1405" data-mp="129b7nnpl34dv">
              {error}
            </p>}
          <Button type="submit" size="lg" loading={sending} className="w-full" data-id="element-1406" data-mp="3v6pa0f6bnhvm">
            Enviar enlace
          </Button>
        </form>}
    </AuthLayout>;
}